module.exports = "<div class=\"recommended_content_items\"></div>";